import { render, staticRenderFns } from "./chantal3.vue?vue&type=template&id=e4bbdf10"
import script from "./chantal3.vue?vue&type=script&lang=js"
export * from "./chantal3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports